/**
 * BETA-COMMERCE-298 (P0-1): one grading-flow instance for the whole /maestro/grade/* route family.
 *
 * ⛔ THE ROUTE BOUNDARY IS THE POINT. Upload, processing and results are three ROUTES, so a hook
 * called inside each of them is three independent states. Lifting the state ABOVE the <Routes>
 * boundary is what makes the grade computed on the upload screen visible on the results screen.
 */
import { GradingFlowContext, useGradingFlowState } from './useGradingFlow';

export default function GradingFlowProvider({ children }) {
  const flow = useGradingFlowState();
  return <GradingFlowContext.Provider value={flow}>{children}</GradingFlowContext.Provider>;
}
